import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from './LanguageContext';
export function WhyDifferent() {
  const {
    t
  } = useLanguage();
  const cards = [{
    number: '01',
    titleKey: 'why.card1.title',
    descKey: 'why.card1.desc'
  }, {
    number: '02',
    titleKey: 'why.card2.title',
    descKey: 'why.card2.desc'
  }, {
    number: '03',
    titleKey: 'why.card3.title',
    descKey: 'why.card3.desc'
  }];
  return <section className="py-32 bg-svt-bg relative transition-colors duration-300" data-id="element-158">
      <div className="container mx-auto px-6 relative z-10" data-id="element-159">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-20" data-id="element-160">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-svt-text" data-id="element-161">
            {t('why.title1')}{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-svt-pink to-svt-purple" data-id="element-162">
              {t('why.title2')}
            </span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-163">
          {cards.map((card, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group relative p-1 rounded-3xl bg-gradient-to-b from-svt-border to-transparent hover:from-svt-pink/30 hover:to-svt-purple/10 transition-all duration-500" data-id="element-164">
              <div className="h-full p-8 rounded-[23px] bg-svt-card flex flex-col relative overflow-hidden transition-colors duration-300" data-id="element-165">
                <div className="absolute inset-0 bg-gradient-to-br from-svt-pink/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-166"></div>

                <div className="relative z-10" data-id="element-167">
                  <div className="text-6xl font-black text-transparent bg-clip-text bg-gradient-to-b from-svt-text-faint/40 to-transparent mb-6" data-id="element-168">
                    {card.number}
                  </div>
                  <h3 className="text-xl font-bold mb-4 text-svt-text group-hover:text-svt-pink-light transition-colors" data-id="element-169">
                    {t(card.titleKey)}
                  </h3>
                  <p className="text-svt-text-muted text-sm leading-relaxed font-light" data-id="element-170">
                    {t(card.descKey)}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-svt-border to-transparent" data-id="element-171"></div>
    </section>;
}